module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title",
    attrs: {
      "id": "list"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The swastika flag flying over Den Burg, Texel’s main town. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aeronautical and War Museum Texel (LOMT)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("One of the German bunkers on the island. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Indian soldiers serving in the Wehrmacht. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(LOMT)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The Hotel de Lindeboom, HQ of the German occupation forces. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A German soldier on Texel fraternising with local women. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("German soldiers enjoying a beer. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A German soldier having a snooze on the peaceful island. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("German personnel queuing for rations. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("German troops playing games on Texel. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Members of the Georgian Legion. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Georgians of the 822nd Battalion relaxing. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Local Dutch Nazis. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LOMT")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Shalva Loladze, leader of the uprising. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wikipedia")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Two wounded Georgian soldiers. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wikipedia")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The bloodstained map used by Shalva Loladze. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The old lighthouse on Texel. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The Georgian Military Cemetery. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Poster for the Soviet film "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crucified Island")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Memorial for Cornelia Boon-Verberg. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The grave of Evgeni Artemidze. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa60f004","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Listofplates.vue
// module id = 72
// module chunks = 0